export enum EAccessTypes {
  HAVE_NOT_ACCESS = '0',
  HAVE_ACCESS = '1'
}
